import React, { useState } from "react";
import { Share2 } from "lucide-react";
import ShareModal from "./ShareModal";

/** Small icon button that opens the TRANSMIT share modal. Usable anywhere. */
export default function ShareButton({ url, title, size = 13, testid, className = "" }) {
  const [open, setOpen] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(true); }}
        data-testid={testid || "share-btn"}
        aria-label="Transmit"
        className={`p-2 border border-[color:var(--sat-border)] text-[color:var(--sat-text-dim)] hover:border-[color:var(--sat-cyan)] hover:text-[color:var(--sat-cyan)] transition-all ${className}`}>
        <Share2 size={size} strokeWidth={1.5} />
      </button>
      <ShareModal open={open} onClose={() => setOpen(false)} url={shareUrl} title={title} testid={`share-modal-${testid || 'default'}`} />
    </>
  );
}
